import moment from 'moment';
import { useState, useEffect } from 'react';

export const DateTime = () => {
    const [state, setState] = useState({
        time: moment().format("LTS"),
        date: moment().format("dddd MMM DD, YYYY")
    });

    useEffect(() => {
        const interval = setInterval(() => {
            setState({
                time: moment().format("LTS"),
                date: moment().format("dddd MMM DD, YYYY")
            });
        }, 1000);

        return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    return (
        <div className="row">
            <div className="col-12" style={{ textAlign: "center", color: '#3cd2a5' }}>
                <h4 style={{ color: '#3cd2a5' }}>{state.date}</h4> <br />
                <h2 style={{ color: '#3cd2a5' }}>{state.time}</h2>
            </div>
        </div>
    );
};
